// biome-ignore lint/style/useNodejsImportProtocol: its ok to use relative path here
import qs, { type ParsedUrlQuery } from 'querystring';
import { BASE_EXTERNAL_EXCLUDED_PARAMS } from '@/components/shared/JoinCTA';
import check from '@/static/assets/pet/checkmark.svg';
import checkRounded from '@/static/assets/pet/checkmark_circle.svg';
import Image from 'next/image';
import type React from 'react';

export const CheckMarkIcon: React.FC = () => {
  return <Image alt="check icon" src={check} />;
};

export const CheckMarkCircleIcon: React.FC = () => {
  return <Image alt="check icon" src={checkRounded} />;
};

export enum PetLandingPageType {
  Dog = 'dog',
  Cat = 'cat',
  PetInsurance = 'pet_insurance',
}

/**
 * Make sure to pass any utm related qs to the redirect page
 * @param query the map structure for URL query params
 * @returns the redirect path with qs if exists
 */
export const getDestinationUrlWithQueryParams = (query: ParsedUrlQuery): string => {
  const queryParams: Record<string, string | string[] | undefined> = {};
  Object.keys(query).forEach(key => {
    if (!BASE_EXTERNAL_EXCLUDED_PARAMS.includes(key)) {
      queryParams[key] = query[key];
    }
  });
  const isEmptyQuery = Object.keys(queryParams).length === 0;
  return !isEmptyQuery ? `/pet?${qs.stringify(queryParams)}` : '/pet';
};
